import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Select} from 'antd';
import {tagService} from '../../services/tag';
import {debounce} from '../../utils/debounce';
import './index.scss';

export function TagSelect({value, onChange, disabled}: any) {
  const [options, setOptions] = useState<{ label: string, value: string }[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchTags = useCallback(async (keyword = '') => {
    setLoading(true);

    try {
      const res = await tagService.search({name: keyword});
      const list = Array.isArray(res) ? res : res?.data || [];

      setOptions(
        list.map((item: any) => ({
          label: item.tag_name,
          value: item.tag_name
        }))
      );
    } finally {
      setLoading(false);
    }
  }, []);

  const debounceFetchTags = useMemo(() => {
    return debounce((keyword: string) => {
      void fetchTags(keyword);
    }, 300);
  }, [fetchTags]);

  useEffect(() => {
    void fetchTags('');
  }, [fetchTags]);

  return (
    <Select
      disabled={disabled}
      className="drive-tag-select"
      dropdownClassName="drive-tag-select-dropdown"
      mode="tags"
      value={value}
      options={options}
      loading={loading}
      onSearch={debounceFetchTags}
      onChange={onChange}
      filterOption={false}
      placeholder="输入或选择标签"
      notFoundContent={loading ? '搜索中...' : '暂无标签，可直接输入创建'}
    />
  );
}